import script from "./PackSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./PackSelector.vue?vue&type=script&setup=true&lang=js"

import "./PackSelector.vue?vue&type=style&index=0&id=52ceec5b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52ceec5b"]])

export default __exports__